export default __webpack_public_path__ + "56083c19e5685bf156231201fb8225e3.svg";